import clsx from "clsx";
import CheveronLeftBold from "shared/icons/CheveronLeftBold";
import PlusIcon from "shared/icons/PlusIcon";
import CrossOutlined from "shared/icons/CrossOutlined";

interface Images {
  url: string;
  file?: File;
  id: string | number;
}

interface ChatImagePreviewProps {
  selectedImage?: string;
  imageUrl: Images[];
  imageIndex: number;
  isEditDisable: boolean;
  onRemoveImage(index: number): void;
  onChangeSelectedImage(imageIndex: number): void;
  onDisableImagePreview(): void;
  uploadRef: React.RefObject<HTMLInputElement>;
}

export default function ChatImagePreview({
  selectedImage,
  imageUrl,
  imageIndex,
  isEditDisable,
  onRemoveImage,
  onChangeSelectedImage,
  onDisableImagePreview,
  uploadRef,
}: ChatImagePreviewProps) {
  return (
    <div
      className={clsx(
        "image-preview-wrapper",
        isEditDisable && "view-preview-images"
      )}
    >
      <div className={"btn-container"}>
        <div onClick={onDisableImagePreview}>
          <CheveronLeftBold />
        </div>
        {/* Download Function  will be added */}
        {/* {
          isEditDisable &&
          <Button color='squared'>Download</Button>
        } */}
      </div>
      <div className={"preview-image-container"}>
        <div className={"image-container"}>
          <img src={selectedImage || ""} alt="" className={"preview-image"} />
        </div>
        <div className={"preview-tools"}>
          {imageUrl.length < 10 && !isEditDisable && (
            <div
              className={"add-more-btn"}
              onClick={() => uploadRef.current?.click()}
            >
              <PlusIcon />
            </div>
          )}
          {imageUrl.map((eachImage, index) => {
            return (
              <div
                key={index}
                className={clsx(
                  "multiple-image-slider",
                  imageIndex === index && "selected-image"
                )}
              >
                <div
                  className={"image-slider"}
                  onClick={() => onChangeSelectedImage(index)}
                >
                  <img src={eachImage.url} alt="" className={"image-slider"} />
                </div>
                {!isEditDisable && imageUrl.length > 1 && (
                  <div
                    className={"cross-icon"}
                    id="remove-image-btn"
                    onClick={(e) => onRemoveImage(index)}
                  >
                    <CrossOutlined />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
